import { Flexbox, Text } from "@sede-x/shell-ds-react-framework";
import { TMovementGroup } from "ticketing/ticketing.types";
import { formatNumber, isGainLoss } from "ticketing/utils";

const MovementGroupContainerLabel = ({
  movementGroups
}: {
  movementGroups: TMovementGroup[] | null | undefined;
}) => {
  if (movementGroups == null || movementGroups.length === 0) {
    return <></>;
  }

  const numUom = [...new Set(movementGroups.map(m => m.activeMovement.unitOfMeasure.id))]
    .length;

  if (numUom !== 1) {
    return <></>;
  }

  const isTransitComplete =
    movementGroups.some(g => Boolean(g.activeMovement.batch.transitComplete)) ?? false;

  const isGainLossNom = (movementGroup: TMovementGroup) =>
    movementGroup?.activeMovement?.isActualizedExternally && //2575178
    isGainLoss(movementGroup);

  const movementScheduledQuantity = (movementGroup: TMovementGroup) =>
    isGainLossNom(movementGroup)
      ? movementGroup.activeMovement.netQuantity
      : movementGroup.activeMovement.scheduledQuantity;

  const movementRemainingQuantity = (movementGroup: TMovementGroup) =>
    movementGroup?.activeMovement?.actualizationComplete
      ? 0
      : Math.max(
          0,
          movementScheduledQuantity(movementGroup) -
            (movementGroup.activeMovement.actualizedQuantity ?? 0)
        );

  const totalScheduledQuantity = movementGroups.reduce(
    (accumulator, currentValue) => movementScheduledQuantity(currentValue) + accumulator,
    0
  );

  const totlaActualizedQuantity = movementGroups.reduce(
    (accumulator, currentValue) =>
      accumulator + (currentValue.activeMovement.actualizedQuantity ?? 0),
    0
  );

  const totalRemainingQuantity = movementGroups.reduce(
    (accumulator, currentValue) => accumulator + movementRemainingQuantity(currentValue),
    0
  );

  return (
    <Flexbox gap="16px">
      <Flexbox className="quantity-label">
        <Text bold style={{ fontSize: "0.875rem" }}>
          {" "}
          Sch:&nbsp;
        </Text>
        <Text bold style={{ color: "var(--primary-icon-color)", fontSize: "0.875rem" }}>
          {formatNumber(totalScheduledQuantity)}
        </Text>
      </Flexbox>
      <Flexbox className="quantity-label">
        <Text bold style={{ fontSize: "0.875rem" }}>
          Act:&nbsp;
        </Text>
        <Text bold style={{ color: "limegreen", fontSize: "0.875rem" }}>
          {formatNumber(totlaActualizedQuantity)}
        </Text>
      </Flexbox>
      {!isTransitComplete && (
        <Flexbox className="quantity-label">
          <Text bold style={{ fontSize: "0.875rem" }}>
            {" "}
            Rem:&nbsp;
          </Text>
          <Text bold style={{ color: "orangered", fontSize: "0.875rem" }}>
            {formatNumber(totalRemainingQuantity)}
          </Text>
        </Flexbox>
      )}
    </Flexbox>
  );
};

export default MovementGroupContainerLabel;
